import filters from '../../filters'
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import ExportButton from '../elements/ExportButton'

export default {
    filters,
    components: { ExportButton },
    created() {
        if (!this.$router) {
            window.onpopstate = (event) => {
                this.softReset();
                this.resolve();
                this.load();
            };
        }
    },
    computed: {
        ...mapState({ 
            isBusy: state => state.dataView.isBusy,
            results: state => state.dataView.resultSet,
            filters: state => state.dataView.currentFilters,
            currentPage: state => state.dataView.currentPage,
            searchTerm: state => state.dataView.searchTerm,
            layout: state => state.dataView.layout,
        }),
        ...mapGetters({
            isFiltered: 'dataView/isFiltered',
            hasResults: 'dataView/hasResults',
            savedViewMenuOptions: 'dataView/savedViewMenuOptions',
            hasMorePages: 'dataView/hasMorePages',
            hasPreviousPages: 'dataView/hasPreviousPages',
        }),
    },
    methods: {
        ...mapActions({ 
            resolve: 'dataView/resolveFiltersAndOrderFromUrl',
            load: 'dataView/get',
            loadAll: 'dataView/getAll',
            loadSavedViews: 'dataView/load', 
            setResource: 'dataView/setResource',
            setResourceAndLoad: 'dataView/setResourceAndLoad',
            softReset: 'dataView/softReset',
            hardReset: 'dataView/hardReset',
            reset: 'dataView/reset',
            setQueryString: 'dataView/setQueryString',
            viewSelected: 'dataView/setViewFromOption',
            search: 'dataView/search',
        }),
        ...mapMutations({ 
            setResourceRelations: 'dataView/setResourceRelations',
            setDefaultSortOrder: 'dataView/setDefaultSortOrder',
            setAdditionalDefaultParams: 'dataView/setAdditionalDefaultParams',
            setNamespacesToLoad: 'dataView/setNamespacesToLoad',
            setCurrentNamespace: 'dataView/setCurrentNamespace',
            setHasResourceOptions: 'dataView/setHasResourceOptions',
            setFilterOverride: 'dataView/setFilterOverride',
            setSortOrder: 'dataView/setSortOrder', 
            setPage: 'dataView/setPage',
            setPerPage: 'dataView/setPerPage',
            setFilter: 'dataView/setFilter',
            removeFilter: 'dataView/removeFilter',
            setFilters: 'dataView/setFilters',
            setDefaultFilter: 'dataView/setDefaultFilter',
            removeDefaultFilter: 'dataView/removeDefaultFilter',
            setDefaultFilters: 'dataView/setDefaultFilters',
            setTitle: 'dataView/setTitle',
            setIsSavedView: 'dataView/setIsSavedView',
            setLayout: 'dataView/setLayout',
            setDefaultLayout: 'dataView/setDefaultLayout',
        }),
        setDefaultViewAndLoad(viewName, resource) {
            let url = new URL(window.location);
            if (!url.searchParams.has('title')) {
                this.setResource(resource);

                this.loadSavedViews().then(() => {
                    let today = this.viewOptions.find(i => i.label === viewName)
                    this.viewSelected(today)
                })
            } else {
                this.setResourceAndLoad(resource);
            }
        },
        doExport(i) {
            this.exportTo({ format: i.method })
        }
    },
}